import { apiGet } from '../api.ts'
import { useQuery } from '@tanstack/react-query'
import { QueryCacheKeys } from '@/api/queryKeys.ts' // QueryCacheKeys에 fallDetection 추가 필요
import { IPagingReq, IPagingRes } from '@/api/paging.ts'
import { createUrl } from '@/util/url.ts'
import { IAlert, IProtectee, IProtector } from '@/api/notification/getNotificationSos.ts'

export interface IPosition {
    latitude: number;
    longitude: number;
    address?: string;
}

// 요청 파라미터 타입 (기존 IReqGetUrgentHistory와 동일할 수 있으나, 명확히 하기 위해 새로 정의 고려)
interface IReqGetFallDetection extends IPagingReq {
    // query는 optional이므로 여기에 포함하지 않음
}

// API 응답에 맞춘 새로운 타입 정의
// GET /alert/falldetection 응답의 data.data[] 내부 객체 타입
export enum FallDetectionResultType {
    EMERGENCY_119 = '119출동',
    MALFUNCTION = '오작동',
    ETC = '기타'
}

export interface IAlertFallDetection {
    id: number
    alert: IAlert
    protectee: IProtectee
    protector: IProtector
}

export interface IAlertFallDetectionItem {
    id: number
    alert: IAlert
    protectee: IProtectee
    protector: IProtector
}

// apiGetNotificationFallDetection 함수 정의
export const apiGetNotificationFallDetection = async ({ pageNum, pageSize }: IReqGetFallDetection, query?: string) => {
    const pathToCall = '/alert/falldetection';
    // API 경로를 '/alert/falldetection'으로 변경
    return await apiGet<IPagingRes<IAlertFallDetectionItem[]>>(createUrl(pathToCall, {
        query: query,
        pageNum: pageNum,
        pageSize: pageSize
    }))
}

// useQueryGetNotificationFallDetection 훅 정의
const useQueryGetNotificationFallDetection = (props: IReqGetFallDetection, query?: string) => {
    return useQuery({
        // QueryCacheKeys.notification.apiGetNotificationFallDetection와 같이 새로운 키 정의 필요
        queryKey: QueryCacheKeys.notification.apiGetNotificationFallDetection(query, props), // props도 키에 포함하여 페이지별 캐싱
        queryFn: async () => {
            const { data } = await apiGetNotificationFallDetection(props, query)
            return data // IPagingRes<IAlertFallDetectionItem[]>를 반환
        },
        // 필요에 따라 staleTime, cacheTime 등 옵션 추가 가능
    })
}

export default useQueryGetNotificationFallDetection

// 기존 EmergencyAlertConfirmStatus, EmergencyAlertType 등 enum은 필요 시 이 파일 또는 공통 파일로 옮기거나 재정의
// 우선 getNotificationSos.ts의 것을 참조한다고 가정
export { EmergencyAlertConfirmStatus, EmergencyAlertType } from './getNotificationSos' 